import React, { useEffect } from 'react';
import { LukosPDVHero, LukosPDVFeatures } from '../../components/custom/LukosPDVPremium/LukosPDVPremium';
import { motion } from 'framer-motion';

const LukosPDVPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <LukosPDVHero />
        
        <section className="py-20 bg-blue-600 text-center text-white">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-black mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>O PDV mais rápido do Brasil a um clique de você.</h2>
            <button className="bg-white text-blue-600 px-10 py-4 rounded-full font-bold text-lg shadow-xl hover:bg-slate-100 transition-all">
              Agendar apresentação estratégica
            </button>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default LukosPDVPage;
